
import { Component, Vue, Prop } from "vue-property-decorator";

import MarkdownContent from "@/components/elements/MarkdownContent.vue";

@Component({
  components: {
    MarkdownContent
  }
})
export default class TermsOfService extends Vue {
  public content = "";

  async mounted() {
    const res = await fetch("/policies/terms.md");
    this.content = await res.text();
  }

  get title() {
    return "Terms of Service";
  }
}
